import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

import { LaunchFlowBasics } from 'components/launch/launch-flow-basics';
import { LaunchFlowGithub } from 'components/launch/launch-flow-github';
import { LaunchFlowUpload } from 'components/launch/launch-flow-upload';
import { useStore, useWorkspace } from 'contexts';

const LaunchFlow = ({ model, initialView, open, setOpen }) => {
	const [project, setProject] = useState<any>({});
	const [view, setView] = useState<any>('basics');
	const workspace = useWorkspace();
	const router = useRouter();
	const store = useStore();

	// Computed
	const rootApi = project.uuid ? `${workspace.rootApi}/projects/${project.uuid}` : '';
	const contexts = { workspace, router, store };

	// Hooks
	useEffect(() => {
		if (open) {
			setProject(model);
			setView(initialView);
		}
	}, [open]);

	// Methods
	const onClose = () => setOpen(!open);
	const onView = view => setView(view);
	const onSave = data => {
		if (!data?.id) return;
		setProject(data);
		onFinish(data);
	};
	const onFinish = data => {
		const target = data?.id ? data : project;
		router.push(target.appPath || target.webPath || (target.uuid ? `/projects/${target.uuid}` : '/projects'));
	};

	// Props
	const props = { model: project, rootApi, contexts, open, setOpen, onClose, onView };

	// Render
	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form'>
				{view === 'basics' && <LaunchFlowBasics {...props} onNext={onSave} />}
				{view === 'github' && <LaunchFlowGithub {...props} onNext={onSave} />}
				{view === 'upload' && <LaunchFlowUpload {...props} onNext={onSave} />}
			</DialogContent>
		</Dialog>
	);
};

export { LaunchFlow };
